import React from 'react';
import { Tooltip } from 'recharts';

// customize the toolkit to show the custom values instead of the values in the axises 
const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    
    return (
      <div className="bg-blue-gray-900 text-white p-3 rounded-md">
       
         <p className='font-bold'>{` ${ payload[0].payload.date}`}</p>
        <p>{` ${ payload[0].payload.availability}`}</p>
        <p>{` Memory :  ${payload[0].payload.memory ?  payload[0].payload.memory : 'N/A'}`}</p>
      </div>
    );
  }

  return null;
};

export default CustomTooltip;
